export enum FieldTypes {
    boolean = 'boolean',
    string = 'string',
    integer = 'integer',
    float = 'float',
    dropdown = 'dropdown',
}

export const FLOAT_MAXIMUM_PRECISION = 2;
